import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`


@import url(https://fonts.googleapis.com/css?family=Inter:100,200,300,regular,500,600,700,800,900);
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }


  body {
    font-family: 'Inter', sans-serif;
    overflow-x: hidden;
  }

  .padding {
    padding: 149px 156px 150px;
  }




`;
